import {getToken, setToken} from '@/utils/auth'
import {login, loginBySmsCode} from '@/api/user'
import {resetRouter} from '@/router'
import de from "element-ui/src/locale/lang/de";
import store from "@/store";

const getDefaultState = () => {
    return {
        token: getToken(),
        name: '',
        avatar: '',
        roles: [],
        roleList: []
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    }
}

const actions = {
    // user login
    login({commit}, userInfo) {
        console.log(111)
        const {username, password, smsCode, loginType} = userInfo
        console.log(userInfo)
        return new Promise((resolve, reject) => {
            if (loginType == 0) {
                login({userName: username.trim(), pwd: password}).then(response => {
                    commit('SET_TOKEN', response.data.token)
                    setToken(response.data.token)
                    commit('SET_NAME', response.data.userName)
                    sessionStorage.setItem('userName',  response.data.userName);
                    // sessionStorage.setItem('userId', response.info.userId);
                    resolve()
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })
            } else {
                loginBySmsCode({phone: username.trim(), smsCode: smsCode}).then(response => {
                    commit('SET_TOKEN', response.info.token)
                    setToken(response.info.token)
                    commit('SET_NAME', response.info.userName)
                    sessionStorage.setItem('userName',  response.info.userName);
                    sessionStorage.setItem('userId', response.info.userId);
                    resolve()
                }).catch(error => {
                    console.log(error)
                    reject(error)
                })
            }

        })
    },

    // get user info
    getInfo({commit, state}) {
        var _this = this;
        return new Promise((resolve, reject) => {
            getInfo(state.token).then(response => {
                const {data} = response
                if (!data) {
                    reject('Verification failed, please Login again.')
                }

                const {roleList, roles, name, avatar} = data

                // roles must be a non-empty array
                if (!roles || roles.length <= 0) {
                    reject('getInfo: roles must be a non-null array!')
                }

                commit('SET_ROLES', roles)
                commit('SET_NAME', name)
                setUserName(name)
                commit('SET_AVATAR', avatar)

                // commit('SET_ROLELIST', roleListt)
                let roleMenuList = _this.pinPromise(roleList)
                commit('SET_ROLELIST', roleMenuList)
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    // user logout
    logout({commit, state}) {
        return new Promise((resolve, reject) => {
            localStorage.removeItem("bdwatch_training");
            commit('RESET_STATE')
            location.reload()
        })
    },

    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            commit('RESET_STATE')
            resolve()
        })
    },
    pinPromise(data) {
        var compare = function (obj1, obj2) {
            var val1 = obj1.sort;
            var val2 = obj2.sort;
            if (val1 < val2) {
                return -1;
            } else if (val1 > val2) {
                return 1;
            } else {
                return 0;
            }
        }
        if (data.ifMap) {
            let routers = [];
            for (var key in data.ifMap) {
                var menu = data.ifMap[key].menuInfo;
                var btns = data.ifMap[key].menuBtnList
                var router = {
                    sort: menu.sort,
                    path: menu.url,
                    menuId: menu.menuId,
                    pid: menu.pid,
                    meta: {btns: btns},
                    name: menu.menuName,
                    iconCls: menu.menuIcon, //图标样式class
                    children: []
                };
                //{ path: '/nav1/table', component: Table, name: 'Table' }
                if (router.pid > 0) {
                    var prouter = routers.find(e => e.menuId == router.pid);
                    if (prouter) {
                        prouter.children.push(router)
                    } else {
                        var pmenu = this.menulist.find(e => e.menuId == router.pid);
                        if (pmenu) {
                            var prouter = {
                                sort: pmenu.sort,
                                path: pmenu.url,
                                menuId: pmenu.menuId,
                                pid: pmenu.pid,
                                meta: {btns: btns},
                                redirect: pmenu.url,
                                name: pmenu.menuName,
                                iconCls: pmenu.menuIcon, //图标样式class
                                children: [router]
                            };
                            routers.push(prouter)
                        }
                    }
                } else {
                    routers.push(router)
                }
            }
            routers.forEach(e => {
                e.children = e.children.sort(compare)
            })
            // console.log(routers.sort(compare))
            return routers.sort(compare)
        }
        return []
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js